<section class="aarni-font w-full shadow border-b  py-[50px] mt-[80px]">
    <div class="container mx-auto px-4">
        <h1 class=" text-center md:text-start font-bold text-[32px]">
            {{ pageTitle }}
        </h1>
    </div>
</section>

<section class="aarni-font text-justify">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-fit lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4 border-b">Research</h2>
                    <div class="">
                        <a [href]="'/research/research-paper-publication'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Research Paper Publication', 'text-blue-600 bg-white' : pageTitle !== 'Research Paper Publication'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Research Paper Publication</span>
                        </a>
                        <a [href]="'/research/book-publication-details'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Book Publication Details', 'text-blue-600 bg-white' : pageTitle !== 'Book Publication Details'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Book Publication Details</span>
                        </a><a [href]="'/research/book-chapters-publication'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Book Chapters Publication', 'text-blue-600 bg-white' : pageTitle !== 'Book Chapters Publication'}"
                               class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                    >
                        <i class="fa fa-arrow-right"></i>
                        <span>Book Chapters Publication</span>
                    </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Faculty</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Leadership</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1 aarni-font">
            <div class="p-4 md:p-8 h-fit shadow-md bg-white">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle==='Research Paper Publication'" class="mt-5">
                    <div class="md:flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow hidden">
                        <iframe
                            src="assets/pdf/research-paper-publication-details.pdf"
                            width="100%"
                            height="600px"
                            style="border: none;"
                        ></iframe>
                 <!--       <iframe
                            class="my-8"
                            src="assets/pdf/dr-gurvinder-singh-research-paper-publication-details.pdf"
                            width="100%"
                            height="600px"
                            style="border: none;"
                        ></iframe>-->
                    </div>
                    <div>
                        <a
                            href="assets/pdf/research-paper-publication-details.pdf"
                            target="_blank"
                            rel="noopener"
                            class="text-blue-600 underline block md:hidden"
                        >
                          Research Paper Publication Details
                        </a>
                    <!--    <a
                            href="assets/pdf/dr-gurvinder-singh-research-paper-publication-details.pdf"
                            target="_blank"
                            rel="noopener"
                            class="text-blue-600 underline block md:hidden"
                        >
                            Dr. Gurvinder Singh, Research Paper Publication Details
                        </a>-->
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Book Publication Details'" class="mt-5">
                    <div class="md:flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow hidden">
                        <iframe
                            src="assets/pdf/books-publication-details.pdf"
                            width="100%"
                            height="600px"
                            style="border: none;"
                        ></iframe>
                    </div>
                    <div>
                        <a
                            href="assets/pdf/books-publication-details.pdf"
                            target="_blank"
                            rel="noopener"
                            class="text-blue-600 underline block md:hidden"
                        >
                          Book Publication Details
                        </a>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Book Chapters Publication'" class="mt-5">
                    <div class="md:flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow hidden">
                        <iframe
                            src="assets/pdf/details-of-chapters.pdf"
                            width="100%"
                            height="600px"
                            style="border: none;"
                        ></iframe>
                    </div>
                    <div>
                        <a
                            href="assets/pdf/details-of-chapters.pdf"
                            target="_blank"
                            rel="noopener"
                            class="text-blue-600 underline block md:hidden"
                        >
                           Book Chapters Publication
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
